<div class="company-activity-section">
  <div class="activity-feed-header">
    <h3>{{ 'activityFeed.companyActivity' | translate }}</h3>
    <div class="controls">
      <mat-button-toggle-group [value]="selectedPeriod" (change)="onPeriodChange($event)">
        <mat-button-toggle value="24h">24h</mat-button-toggle>
        <mat-button-toggle value="7d">7d</mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-icon-button [matMenuTriggerFor]="filterMenu">
        <mat-icon>filter_list</mat-icon>
      </button>
      <mat-menu #filterMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let group of filterGroups"
          (click)="onFilterChange(group)"
          [class.selected]="selectedFilterGroup === group">
          {{ group.translationKey | translate }}
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading-state">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Activity list -->
  <div class="activity-list" *ngIf="!isLoading">
    <div class="activity-item" *ngFor="let activity of activities">
      <div class="activity-icon">
        <mat-icon [style.color]="getActivityColor(activity.activityType)">
          {{ getActivityIcon(activity.activityType) }}
        </mat-icon>
      </div>
      <div class="activity-content">
        <span class="activity-campaign" *ngIf="activity.quizTitle">
          {{ activity.quizTitle }}
        </span>
        <span class="activity-summary">{{ getSummaryKey(activity.activityType) | translate:getSummaryParams(activity) }}</span>
        <span class="activity-detail" *ngIf="getActivityDetail(activity)">
          {{ getActivityDetail(activity) }}
        </span>
      </div>
      <span class="activity-timestamp">{{ activity.createdAt | talentmarketDatePipe }}</span>
    </div>

    <!-- Empty state -->
    <div *ngIf="activities.length === 0" class="empty-state">
      <mat-icon>inbox</mat-icon>
      <p>{{ 'activityFeed.noActivities' | translate }}</p>
    </div>
  </div>
</div>
